import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fitnessGoalsActions } from './fitness-goals.actions';
import { map } from 'rxjs/operators';
import {profileApiActions} from "@fitup-monorepo/core/lib/state/profile/profile.actions";

@Injectable()
export class FitnessGoalsEffects {
  private readonly actions$ = inject(Actions);

  public readonly updateCustomer$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fitnessGoalsActions.updateCustomer),
      map(customer => profileApiActions.updateCustomer(customer))
    )
  );
}
